import { Progress as ProgressPrimitive } from '@base-ui/react/progress';

import { cn } from '@/lib/utils';

export type ProgressProps = ProgressPrimitive.Root.Props;

const Progress = ({ className, children, value, ...props }: ProgressProps) => {
  return (
    <ProgressPrimitive.Root
      value={value}
      data-slot="progress"
      className={cn('flex flex-wrap gap-2', className)}
      {...props}
    >
      {children}
    </ProgressPrimitive.Root>
  );
};

export default Progress;
